import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../../components/Navbar';

const MENUS = [
  {
    id: 1,
    name: 'Authentic Palpali Bhoj Package',
    price: 'NPR 450 / guest',
    items: ['Palpali Chukauni (Spiced Yoghurt Potato)', 'Batuk & Sel Roti (Traditional Bread)', 'Local Mutton Curry / Local Chicken', 'Steamed Basmati Rice & Dal Fry', 'Mixed Pickle & Fresh Salad', 'Gulab Jamun / Jalebi'],
    tag: 'Palpali Specialty',
    emoji: '🍱',
    manager: 'Krishna Khanal (9867155395)'
  },
  {
    id: 2,
    name: 'Newari Samay Baji Feast',
    price: 'NPR 600 / guest',
    items: ['Samay Baji & Baji (Beaten Rice)', 'Choila (Spiced Marinated Meat)', 'Kachila & Wo (Bara Lentil Patties)', 'Aalu Wala & Fried Bhatmas', 'Bhaktapur Juju Dhau (King Curd)', 'Traditional Beverages'],
    tag: 'Newari Feast',
    emoji: '🍲',
    manager: 'Sabitri Master Chefs'
  },
  {
    id: 3,
    name: 'Grand Royal Banquet Multi-Cuisine Buffet',
    price: 'NPR 850 / guest',
    items: ['Paneer Butter Masala & Dal Makhani', 'Butter Chicken / Fish Fry', 'Veg Pulao & Naan Bread', 'Live Pasta & Chaat Counter', 'Ice Cream & Chocolate Fountain', 'Soft Drinks & Mocktails'],
    tag: 'Royal Banquet',
    emoji: '👑',
    manager: 'Krishna Khanal (9867155395)'
  }
];

export default function Menu() {
  const navigate = useNavigate();

  return (
    <div className="pi">
      <Navbar />

      <div className="sec-wrapper">
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <span className="badge-light">✦ Sabitri Catering Feast Menus ✦</span>
          <h1 className="section-title">Festive & Royal Packages</h1>
          <p style={{ color: '#718096', maxWidth: '650px', margin: '0.4rem auto 0', fontSize: '0.92rem' }}>
            Managed by <strong>Krishna Khanal</strong> (9867155395) & Partner <strong>Laxmikant Timilsina</strong> (Office: Yogikuti Chowk, Butwal-10). 5-Star certified hygiene.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '2rem',
          marginBottom: '3.5rem'
        }}>
          {MENUS.map((m) => (
            <div key={m.id} className="card pillar-card" style={{ textAlign: 'left', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.8rem' }}>
                  <div style={{ fontSize: '2.5rem' }}>{m.emoji}</div>
                  <span className="badge-light">{m.tag}</span>
                </div>

                <h3 style={{ fontSize: '1.65rem', fontWeight: 800, color: '#004d40', marginBottom: '0.2rem' }}>
                  {m.name}
                </h3>
                <div style={{ fontSize: '1.4rem', fontWeight: 900, color: '#0097a7', marginBottom: '0.6rem' }}>
                  {m.price}
                </div>
                <div style={{ fontSize: '0.78rem', color: '#00796b', fontWeight: 700, marginBottom: '1.2rem' }}>
                  👨‍🍳 {m.manager}
                </div>

                <ul style={{ listStyle: 'none', fontSize: '0.86rem', color: '#4a5568', lineHeight: 1.8, marginBottom: '1.5rem' }}>
                  {m.items.map((item, idx) => (
                    <li key={idx} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <span style={{ color: '#00796b', fontWeight: 800 }}>✓</span> {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <button className="btn btn-primary btn-full" onClick={() => navigate('/catering/booking')}>
                  Book Catering for Event →
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Custom Menu Request CTA */}
        <div className="card" style={{ textAlign: 'center', background: 'linear-gradient(135deg, #004d40, #00695c)', color: 'white' }}>
          <h3 style={{ fontFamily: 'var(--serif)', fontSize: '1.8rem', fontWeight: 800, color: 'white', marginBottom: '0.6rem' }}>
            Want a Custom Menu for 500+ Guests?
          </h3>
          <p style={{ fontSize: '0.9rem', color: 'rgba(255,255,255,0.85)', maxWidth: '650px', margin: '0 auto 1.5rem' }}>
            Contact Sabitri Catering director <strong>Krishna Khanal (9867155395)</strong> or visit our office at <strong>Butwal-10, Yogikuti Chowk</strong> for custom menu tasting.
          </p>
          <div style={{ display: 'flex', gap: '0.9rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button className="btn btn-secondary" onClick={() => navigate('/catering/booking')}>
              Request Custom Menu Booking →
            </button>
            <a href="tel:9867155395" className="btn btn-tertiary">
              📞 Call Krishna Khanal (9867155395)
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
